module.exports = "{{displayText}}\r\n{{#if sortingAsc}} <span class=\"sort_down\"></span>{{/if}}\r\n{{#if sortingDesc}} <span class=\"sort_up\"></span>{{/if}}";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/gridcolumnheader.hbs
// module id = 707
// module chunks = 0